import React from "react"
import { Box, Grid, Typography } from "@mui/material"
import { ModalSeeker } from "@ui-seeker/core"

import { AppOfficesBlock } from "@components/DataBlocks/index"
import { officeModalData } from "@signals"
import useOfficeModalFilter from "./@hooks"
import ModalOfficesSelector from "@components/DataBlocks/OfficesModal/Offices"
import ModalCountriesSelector from "@components/DataBlocks/OfficesModal/Countries"
import ModalTypesSelector from "@components/DataBlocks/OfficesModal/Types"


export default function AppOfficesModal({ ...props }) {

	const {
		filteredList,
		filteredOffices,
		onChangeOffice,
		onChangeCountry,
		onChangeType,
		typesOptions,
		countriesOptions,
		applyFilters
	} = useOfficeModalFilter()

	return <ModalSeeker
		isOpen={!!officeModalData.value?.length}
		controller={() => officeModalData.value = []}
		title="Offices List"
		hideActions
		{...props?.modalProps}
	>
		<Grid container spacing={2}>
			<Grid item xs={4}>
				<ModalOfficesSelector
					applyFilters={applyFilters}
					filteredOffices={filteredOffices}
					onChangeOffice={onChangeOffice}
				/>
			</Grid>
			<Grid item xs={4}>
				<ModalCountriesSelector
					applyFilters={applyFilters}
					countriesOptions={countriesOptions}
					onChangeCountry={onChangeCountry}
				/>
			</Grid>
			<Grid item xs={4}>
				<ModalTypesSelector
					applyFilters={applyFilters}
					onChangeType={onChangeType}
					typesOptions={typesOptions}
				/>
			</Grid>
			<Grid item xs={12}>
				{!!filteredList.length && <Box sx={{
					display: "flex",
					alignItems: "start",
					justifyContent: "start",
					flexDirection: "column",
					flexWrap: "wrap",
					height: "30vh",
					...props.containerProps
				}}>
					{filteredList.map(({ name, type, country }, idx) => (
						<AppOfficesBlock
							key={`${name}-${idx}`}
							sx={{ m: .5 }}
							name={name}
							type={type}
							country={country}
							{...props.officeProps}
						/>
					))}

				</Box>}
				{!filteredList.length && <Box sx={{
					display: "flex",
					alignItems: "start",
					justifyContent: "center",
					height: "30vh",
					p: 1
				}}>
					<Typography variant="caption">No results for the given filters</Typography>
				</Box>}
			</Grid>
		</Grid>
	</ModalSeeker>
}